import type { PermissionsCheckRequest } from './PermissionsResponse.types.tsx';
import { GLOBAL_PERMISSIONS, PROJECT_PERMISSIONS } from './SupportedPermissions.tsx';

export const getPermissionsQueryString = (): string =>
	[...PROJECT_PERMISSIONS, ...GLOBAL_PERMISSIONS].join();

export const getPermissionsUrl = (projectId: number): string =>
	`/rest/api/3/mypermissions?projectId=${projectId}&permissions=${getPermissionsQueryString()}&operation=getPermissions`;

export const PERMISSIONS_CHECK_PATH = '/rest/api/3/permissions/check?operation=getPermissions';

export const buildPermissionsCheckRequestBody = (
	projectIds: number[],
): PermissionsCheckRequest => ({
	projectPermissions: [
		{
			// new instance of the array
			permissions: [...PROJECT_PERMISSIONS],
			projects: projectIds,
		},
	],
	// new instance of the array
	globalPermissions: [...GLOBAL_PERMISSIONS],
});
